module.exports = __webpack_public_path__ + "img/sale.09a20251.svg";